import { BarcodeInput } from './BarcodeInput';

interface AdminBarcodeInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
  onValidationChange?: (isValid: boolean) => void;
}

/**
 * AdminBarcodeInput Component
 * 
 * Wrapper around BarcodeInput for admin barcode entry.
 * Handles the admin barcode format and validation.
 */
export function AdminBarcodeInput({
  value,
  onChange,
  disabled = false,
  autoFocus = false,
  onValidationChange,
}: AdminBarcodeInputProps) {
  return (
    <BarcodeInput
      value={value}
      onChange={onChange}
      disabled={disabled}
      label="الباركود الإداري"
      onComplete={(barcode) => {
        // Notify parent of validation status
        if (onValidationChange) {
          onValidationChange(barcode.length === 13);
        }
      }}
    />
  );
}
